export default "__VITE_ASSET__DWOFduGf__"